var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHammerStraight = function SvgHammerStraight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Ebene 1",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.46 9.25 32.2 3.49a2 2 0 0 0-.9-.22h-22a2 2 0 0 0-1.4.58L6.31 5.44a2 2 0 0 0-.59 1.41v7.75a2 2 0 0 0 .59 1.4l1.58 1.6a2 2 0 0 0 1.42.59h7.59v27.54a1 1 0 0 0 1 1h6.43a1 1 0 0 0 1-1V18.19h6a2 2 0 0 0 .95-.24l11.25-6a1.52 1.52 0 0 0 .8-1.35 1.5 1.5 0 0 0-.87-1.35M22.53 44.43H19.7a.5.5 0 0 1-.5-.5V18.19H23v25.74a.5.5 0 0 1-.47.5m9.12-28.78a2 2 0 0 1-.95.24H9a1 1 0 0 1-1-1V6.57a1 1 0 0 1 1-1h21.72a2 2 0 0 1 .9.22l9.42 4.82z"
  })));
};
export default SvgHammerStraight;